var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 0C3.95 0 0 3.8 0 8.49c0 2.17.85 4.23 2.4 5.82l5.32 5.23c.28.3.67.46 1.08.46.4 0 .8-.17 1.07-.46l5.34-5.24A8.3 8.3 0 0 0 17.6 8.5C17.6 3.8 13.65 0 8.8 0Zm0 1.69a6.94 6.94 0 0 1 7.05 6.8c0 1.73-.68 3.38-1.9 4.65L8.8 18.19l-5.14-5.05a6.65 6.65 0 0 1-1.9-4.65c0-3.75 3.15-6.8 7.04-6.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 12.8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.36a2.36 2.36 0 1 1 0 4.73 2.36 2.36 0 0 1 0-4.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.86dab576df5a60d60becb9c0fa3a9a05.svg";
export { ForwardRef as ReactComponent };